import React from "react";
import $ from "jquery"
import {Link} from "react-router-dom"

interface Props {
    title: string,
    icon: JSX.Element,
    url: string,
    isActive?: boolean,
    subMenuId?: string,
    children?: React.ReactNode
}

const PanelSidebarMenuItem: React.FC<Props> = ({title, icon, url, children, subMenuId, isActive = false}) => {
    const handleShowSubMenu = (event: any): void => {
        // event.stopPropagation()
        const subMenu = $(`#${subMenuId}`)
        if(subMenu.hasClass('hidden')){
            subMenu.removeClass('hidden').slideDown()
        }else{
            subMenu.addClass('hidden').slideUp()
        }
    }

    return (
        <div>
            <Link to={url}>
                <div onClick={handleShowSubMenu} className={`${isActive ? "bg-background text-primary" : "text-gray-200"} mr-5 mb-2 flex items-center space-x-2 space-x-reverse py-3 px-3 rounded-r-full transition ease-in-out duration-300 hover:bg-background hover:text-primary`}>
                    <div className="text-xl" >{icon}</div>
                    <div className="text-xl">{title}</div>
                </div>
            </Link>
            {children && <div id={subMenuId} className="hidden submenu-sidebar">
                {children}
            </div>
            }
        </div>
    )
}

export default PanelSidebarMenuItem;